import axios from 'axios';
import { ajaxUri } from '../../../consts/index';
import { l } from '../../../functions';

export const getStoreLogo = (loadIncrement = null) => {
    return dispatch => {
        axios({
            method: 'post',
            url: ajaxUri,
            data: {
                request : 'getStoreLogo'
            }
        })
        .then(result => {
            if( loadIncrement ) dispatch({type:'LOAD_INCREMENT',toAdd:loadIncrement})
            
            dispatch({type:'STORE_LOGO',url:result.data || null});
        })
        .catch(error => {
			console.error(l('Cannot get store logo'))
        });
    }
}